<key-leaflet-map key-content-container
    #map
    [controls]="mapControls"
    [buttons]="buttons"
    (onButtonClicked)="buttonClicked($event)"
    (onReset)="deselectAssets()"></key-leaflet-map>